import { TrialStep } from './TrialTimeline';
import { TargetPlanType } from './types';

import { ReactComponent as SignupIcon } from '../../assets/paywall/signup.svg';
import { ReactComponent as TodayIcon } from '../../assets/paywall/today.svg';
import { ReactComponent as NotSatisfiedIcon } from '../../assets/paywall/notSatisfied.svg';

export const trialSteps: Record<TargetPlanType, Array<TrialStep>> = {
  lifetime: [
    {
      icon: SignupIcon,
      title: 'Sign up for Lifestack',
    },
    {
      icon: TodayIcon,
      title: 'Today: your subscription begins',
      description:
        'Payment charged once. Enjoy your plan in action right away with tasks and routines.',
    },
    {
      icon: NotSatisfiedIcon,
      title: 'Not satisfied?',
      description: 'Please give us feedback to improve Lifestack for you!',
    },
  ],
  monthly: [
    {
      icon: SignupIcon,
      title: 'Sign up for Lifestack',
    },
    {
      icon: TodayIcon,
      title: 'Today: your subscription begins',
      description: 'Payment charged. Enjoy your plan in action right away with tasks and routines.',
    },
    {
      icon: NotSatisfiedIcon,
      title: 'Not satisfied?',
      description: 'Cancel anytime before the next billing date to avoid charges.',
    },
  ],
  yearly: [
    {
      icon: SignupIcon,
      title: 'Sign up for Lifestack',
    },
    {
      icon: TodayIcon,
      title: 'Today: your trial begins',
      description: 'Not charged yet. Enjoy your plan in action right away with tasks and routines.',
    },
    {
      icon: NotSatisfiedIcon,
      title: 'After 7 days:',
      description:
        'After the trial, your subscription will automatically begin and be charged unless you cancel beforehand.',
    },
  ],
};

export const expiredTrialSteps: Record<TargetPlanType, Array<TrialStep>> = {
  lifetime: [
    {
      icon: SignupIcon,
      title: 'Sign up for Lifestack',
    },
    {
      icon: TodayIcon,
      title: 'Today: your subscription begins',
      description:
        'Payment charged once. Enjoy your plan in action right away with tasks and routines.',
    },
    {
      icon: NotSatisfiedIcon,
      title: 'Not satisfied?',
      description: 'Please give us feedback to improve Lifestack for you!',
    },
  ],
  monthly: [
    {
      icon: SignupIcon,
      title: 'Sign up for Lifestack',
    },
    {
      icon: TodayIcon,
      title: 'Today: your subscription begins',
      description: 'Payment charged. Enjoy your plan in action right away with tasks and routines.',
    },
    {
      icon: NotSatisfiedIcon,
      title: 'Not satisfied?',
      description: 'Cancel anytime before the next billing date to avoid charges.',
    },
  ],
  yearly: [
    {
      icon: SignupIcon,
      title: 'Sign up for Lifestack',
    },
    {
      icon: TodayIcon,
      title: 'Today: your subscription begins',
      description: 'Payment charged. Enjoy your plan in action right away with tasks and routines.',
    },
    {
      icon: NotSatisfiedIcon,
      title: 'Not satisfied?',
      description: 'Cancel anytime before the next billing date to avoid charges.',
    },
  ],
};
